(() => {
  const setExpanded = (button, results, expanded) => {
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    results.classList.toggle('pdl-shipping-results--collapsed', !expanded);
    if (expanded) button.dataset.pdlOpenedAt = String(window.scrollY);
  };

  const decorateOptions = (results) => {
    results.querySelectorAll('li').forEach((item) => {
      item.classList.add('pdl-shipping-option');
      const name = (item.querySelector('.ship-name')?.textContent || '').trim();
      const price = (item.querySelector('.ship-price')?.textContent || '').trim();
      item.classList.toggle('pdl-shipping-option--pickup', /retir|retire|loja|pickup/i.test(name));
      item.classList.toggle('pdl-shipping-option--free', /gr[aá]tis|gratuito|r\$\s*0(?:[,.]00)?$/i.test(price));
    });
  };

  const setupBlock = (block) => {
    const form = block.querySelector('#formKokfyShipping');
    const results = block.querySelector('#calc-carrier');
    if (!form || !results) return;

    let button = block.querySelector('.pdl-shipping-results-toggle');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'pdl-shipping-results-toggle';
      button.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      button.innerHTML = '<span class="pdl-shipping-results-toggle__label">Opções de entrega</span><span class="pdl-shipping-results-toggle__chevron" aria-hidden="true"></span>';
      form.insertAdjacentElement('afterend', button);

      button.addEventListener('click', () => {
        const currentResults = block.querySelector('#calc-carrier');
        if (!currentResults) return;
        setExpanded(button, currentResults, button.getAttribute('aria-expanded') !== 'true');
      });
    }

    const sync = () => {
      const currentResults = block.querySelector('#calc-carrier');
      if (!currentResults) return;

      const options = currentResults.querySelectorAll('li');
      const hasContent = options.length > 0 || currentResults.textContent.trim().length > 0;

      if (!hasContent) {
        button.hidden = true;
        return;
      }

      decorateOptions(currentResults);
      button.hidden = false;
      button.querySelector('.pdl-shipping-results-toggle__label').textContent =
        options.length > 0 ? `Opções de entrega (${options.length})` : 'Resultado do frete';

      if (button.dataset.pdlHasResult !== 'true') {
        setExpanded(button, currentResults, true);
        button.dataset.pdlHasResult = 'true';
      }
    };

    if (results.dataset.pdlShippingObserved !== 'true') {
      results.dataset.pdlShippingObserved = 'true';
      new MutationObserver(sync).observe(results, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    if (form.dataset.pdlShippingClick !== 'true') {
      form.dataset.pdlShippingClick = 'true';
      form.addEventListener('click', (event) => {
        if (!event.target.closest('.btnForm')) return;
        button.hidden = true;
        button.dataset.pdlHasResult = 'false';
      }, true);
    }

    sync();
  };

  const init = () => {
    document.querySelectorAll('.product-information .shopify-app-block').forEach((block) => {
      try {
        setupBlock(block);
      } catch (error) {
        console.warn('Pedalokos: não foi possível preparar o resumo do frete.', error);
      }
    });
  };

  init();
  document.addEventListener('DOMContentLoaded', init, { once: true });
  document.addEventListener('shopify:section:load', init);
  window.setInterval(init, 500);

  let pdlMobileScrollTicking = false;
  window.addEventListener('scroll', () => {
    if (window.innerWidth > 749 || pdlMobileScrollTicking) return;

    pdlMobileScrollTicking = true;
    window.requestAnimationFrame(() => {
      document.querySelectorAll('.pdl-shipping-results-toggle[aria-expanded="true"]').forEach((button) => {
        const block = button.closest('.shopify-app-block');
        const results = block?.querySelector('#calc-carrier');
        if (!results) return;

        const openedAt = Number(button.dataset.pdlOpenedAt || window.scrollY);
        const movedDown = window.scrollY - openedAt;
        const headerPassed = button.getBoundingClientRect().bottom < 92;

        if (movedDown > 160 && headerPassed) {
          setExpanded(button, results, false);
        }
      });
      pdlMobileScrollTicking = false;
    });
  }, { passive: true });
})();